import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useGetVehicleDetails from './useGetVehicleDetails';
import {
  selectDealerAndVehicleData,
  setAudiCodeVehicle,
  setCarlineVehicle,
  setVehicle,
} from '../redux/dealerAndVehicleReducer';
import { selectAppConfig } from '../redux/appConfigReducer';
import { CA_MARKET, US_MARKET } from '../constants';
import useFetchByCarline from './fetchHooks/useFetchByCarline';
import useFetchByAudiCode from './fetchHooks/useFetchByAudiCode';

const useVehicleInfo = () => {
  const dispatch = useDispatch();

  const { vehicleId, vehicleType, market, carline, audiCode } = useSelector(selectAppConfig);

  const vehicleMarket = useMemo(() => {
    if (market === CA_MARKET) return vehicleType === 'new' ? 'CA' : 'CAUC';
    return vehicleType === 'new' ? 'US' : 'USUC';
  }, [market, vehicleType]);

  const { vehicleData, isVinVehicleLoading } = useGetVehicleDetails(vehicleId, vehicleMarket);
  const { vehicleCarlineDetails, isCarlineVehicleLoading } = useFetchByCarline(carline, market);
  const { vehicleAudiCodeDetails, isAudiCodeVehicleLoading } = useFetchByAudiCode(audiCode);

  const isVehicleLoading =
    isVinVehicleLoading || isCarlineVehicleLoading || isAudiCodeVehicleLoading;

  useEffect(() => {
    if (vehicleCarlineDetails) {
      dispatch(setCarlineVehicle(vehicleCarlineDetails));
      return;
    }
    if (vehicleAudiCodeDetails) {
      dispatch(setAudiCodeVehicle(vehicleAudiCodeDetails));
      return;
    }
    if (vehicleData) {
      dispatch(setVehicle(vehicleData));
    }
  }, [dispatch, vehicleAudiCodeDetails, vehicleCarlineDetails, vehicleData]);

  const { vehicle } = useSelector(selectDealerAndVehicleData);

  return { vehicle, isVehicleLoading };
};

export default useVehicleInfo;
